import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import configVars from "../../config";
//import { getWithExpiry, setWithExpiry } from '../../common';
import { getUserData } from "../../redux/actions/userdata";

const CommunityLogin = () => {

    const [needAuthentication, setNeedAuthentication] = useState(false);
    const [loading, setLoading] = useState(false);
    const [communityPass, setCommunityPass] = useState('');
    const [authenticated, setAuthenticated] = useState(false);
    const [expired, setExpired] = useState(false);

    const [isError, setIsError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const communityJwt = useSelector(
        (state) => state?.userdata.allUserData?.user_meta?.community_jwt
    );

    const dispatch = useDispatch();

    useEffect(() => {

        if ( ! communityJwt ) setNeedAuthentication(true);

    }, [communityJwt]);

    const getAllUserData = async (token) => {
		setLoading(true);
		await dispatch(getUserData(token));
		setLoading(false)
	}

    const handleCommunityLogin = async (jwt) => {

        if ( !jwt ) {
            setExpired(true);

            return;
        }

        setLoading(true);

        if ( authenticated ) {
            openLink( configVars?.communityUrl );
        } else {

            let userRequestData = new FormData();
            userRequestData.append( 'token', jwt );

            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/refreshcommunityjwt/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const updateResponse = await response.json();
        
                if ( updateResponse ) {
                    
                    if ( updateResponse.success === true ) {

                        const communityUrl = updateResponse.data?.community_url;
                        const passedJwt = updateResponse.data?.refresh_body?.data?.jwt;
                        const authKey =  updateResponse.data?.auth_key;

                        if ( passedJwt && communityUrl ) {
                            const redirectUrl = `${communityUrl}/?rest_route=/simple-jwt-login/v1/autologin&JWT=${passedJwt}&authkey=${authKey}`;

                            openLink( redirectUrl );

                            setNeedAuthentication(false);
                            setAuthenticated(true);

                            getAllUserData(jwt).then( () => {
                                window.location.reload();
                            });
                        }

                    } else {

                        if ( updateResponse.data?.need_password ) {
                            setNeedAuthentication(true);
                        } else {
                            setExpired(true);
                        }
                    }

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

        }

        setLoading(false);

    }

    const handleCommunityAuth = async (jwt) => {
        if ( !jwt ) return;

        setLoading(true);

        let userRequestData = new FormData();
        userRequestData.append( 'token', jwt );
        userRequestData.append( 'user_pass', communityPass );

        const fetchUrl = `${configVars.apiUrl}sustainchange/v1/getcommunityjwt/`;

        try{

            const response = await fetch(
                fetchUrl,
                {
                method: "POST",
                headers: {
                    Authorization: `Basic ${configVars.auth}`,
                },
                body: userRequestData
                }
            );
            
            const updateResponse = await response.json();
    
            if ( updateResponse ) {

                //console.log( updateResponse );
                
                if ( updateResponse.success === true ) {

                    const communityUrl = updateResponse.data?.community_url;
                    const passedJwt = updateResponse.data?.response_body?.data?.jwt;
                    const authKey =  updateResponse.data?.auth_key;

                    if ( passedJwt && communityUrl ) {
                        const redirectUrl = `${communityUrl}/?rest_route=/simple-jwt-login/v1/autologin&JWT=${passedJwt}&authkey=${authKey}`;

                        openLink( redirectUrl );

                        setNeedAuthentication(false);
                        setAuthenticated(true);

                        getAllUserData(jwt);
                    }

                } else {

                    setIsError(true);

                    if ( updateResponse?.data?.response_body?.data?.message ) {
                        setErrorMsg( updateResponse?.data?.response_body?.data?.message );
                    } else {
                        setErrorMsg( 'Authentication failed.' );
                    }

                }
                //console.log( updateResponse );

            }

        } catch( error ) {
            console.log( error );
            return error;
        }

        setLoading( false );

        
    }

    const openLink = (url) => window.open(url, '_blank')?.focus();

    if (expired) {
        return <Redirect to="/login/?logout=true&type=expired" />;
    }

    return (
        <div className="my-4" style={{maxWidth: '500px'}}>
            <div className="row">
                <div className="col-12">

                    {isError &&
                        <div className="alert alert-danger" role="alert">
                            {errorMsg}
                        </div>
                    }

                    { needAuthentication &&
                        <div className="input-group">
                            <input type="password" className="form-control" placeholder="Community Lösenord" value={communityPass} onChange={(e) => setCommunityPass(e.target.value)} />
                            <button className="btn btn-halite-blue" type="button" onClick={() => handleCommunityAuth( cookies.sustainyou_user_jwt ) }>
                                <span className="me-2">Logga in</span>
                                {loading &&
                                    <div className="spinner-border spinner-border-sm text-light" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                }

                                {!loading &&
                                    <span><i className="fa fa-hand-o-right" aria-hidden="true"></i></span>
                                }
                            </button>
                        </div>
                    }

                    { !needAuthentication &&
                        <button type="button" className="btn btn-halite-blue rounded-pill" onClick={ () => handleCommunityLogin(cookies.sustainyou_user_jwt) }>
                            <span className="me-2">Logga in</span>
                            {loading &&
                                <div className="spinner-border spinner-border-sm text-light" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            }

                            {!loading &&
                                <span><i className="fa fa-hand-o-right" aria-hidden="true"></i></span>
                            }
                        </button>
                    }

                </div>
            </div>
        </div>
    )

}

export default CommunityLogin;